import {
  ApiEpBilling,
  IApiEpBillingProductPlanProductListReq,
  IApiEpBillingProductPlanProductRetrieveReq,
} from "@smp/api";
import { Await } from "@smp/utils";
import { useQuery, UseQueryOptions } from "react-query";

const KEY = "ep.billing.product.plan_product";

export const useEpBillingProductPlanProduct = (options: {
  req: IApiEpBillingProductPlanProductRetrieveReq;
  useQueryOptions?: Omit<
    UseQueryOptions<
      Await<ReturnType<typeof ApiEpBilling.Product.PlanProduct.retrieve>>
    >,
    "queryFn" | "queryKey"
  >;
}) => {
  const { data: productPlanProduct, isLoading: isProductPlanProductLoading } =
    useQuery(
      [KEY, options?.req],
      () => ApiEpBilling.Product.PlanProduct.retrieve(options.req),
      options?.useQueryOptions,
    );
  return { isProductPlanProductLoading, productPlanProduct };
};

export const useEpBillingProductPlanProductList = (options: {
  req: IApiEpBillingProductPlanProductListReq;
  useQueryOptions?: Omit<
    UseQueryOptions<
      Await<ReturnType<typeof ApiEpBilling.Product.PlanProduct.list>>
    >,
    "queryFn" | "queryKey"
  >;
}) => {
  const {
    data: productPlanProductList,
    isLoading: isProductPlanProductListLoading,
  } = useQuery(
    [KEY, options?.req],
    () => ApiEpBilling.Product.PlanProduct.list(options?.req),
    options?.useQueryOptions,
  );
  return { isProductPlanProductListLoading, productPlanProductList };
};
